<template>
  <div class="snackbar" data-qa="snackbar-div-1y4jc">
    <v-snackbar
      v-model="config.enabled"
      :timeout="config.timeout"
      :color="config.color"
      :top="config.topPosition"
      :right="config.rightPosition"
      :bottom="config.bottomPosition"
      :left="config.leftPosition"
     data-qa="snackbar-snackbar-gswaka">
     <v-row no-gutters data-qa="snackbar-row-gu4b3b">
        <v-col cols="11" data-qa="snackbar-col-cw615t">
          <span class="snackbar__content subtitle-2 font-weight-regular" data-qa="snackbar-span-fsjkjj">{{ config.content }}</span>
       </v-col>

        <v-col cols="1" data-qa="snackbar-col-68zl8i">
          <v-btn
            @click="config.enabled = false"
            icon
            color="white"
            class="snackbarClose"
           data-qa="snackbar-btn-lndwym">
            <v-icon class="material-symbols-outlined" data-qa="snackbar-icon-pdtgad">close</v-icon>
          </v-btn>
        </v-col>
     </v-row>
    </v-snackbar>
  </div>
</template>

<script>
import '@/styles/components/snackbar.scss'

export default {
  name: 'DOB-Snackbar',
  props: {
    config: {
      type: Object,
      default () {
        return {
          enabled: true,
          content: '',
          color: 'green',
          timeout: 4000,
          topPosition: true,
          rightPosition: true
        }
      }
    }
  }
}
</script>
